import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { UpdateCardsQuery } from "../../../api/query.types";
import { UpdateCardsResponseDTO } from "../../../api/response.types";

import { savedShipmentService } from "../../../api/api";

export const useUpdateCardsMutation = (
  mutationOptions?: UseMutationOptions<UpdateCardsResponseDTO, Error, UpdateCardsQuery>
) => {
  const { mutate, data, isError, isPending, isSuccess } = useMutation<UpdateCardsResponseDTO, Error, UpdateCardsQuery>({
    mutationFn: savedShipmentService.updateCards,
    ...mutationOptions,
  });

  return {
    updateCards: mutate,
    cardsTotalCount: data?.total_count,
    isCardsUpdateSuccess: isSuccess,
    isCardsUpdateError: isError,
    isCardsUpdateLoading: isPending,
  };
};
